/* ============================================================
   L'ATELIER ZEBULON — Coffret sur-mesure Builder
   az-coffret-builder.js · V6 · Cart API Shopify + Fiche rapide
   Paliers : 3→0% | 4-5→-10% | 6-7→-15% | 8-9→-20% | 10+→-25%
   ============================================================ */

(function () {
  'use strict';

  const builderEl = document.getElementById('az-builder');
  if (!builderEl) return;

  const VALISETTE_VARIANT_ID = builderEl.dataset.valisettId;
  const POCHON_VARIANT_ID    = builderEl.dataset.pochonId;
  const MIN_PRODUCTS         = parseInt(builderEl.dataset.minProducts || '3', 10);

  const TIERS = [
    { min: 10, pct: 25 },
    { min: 8,  pct: 20 },
    { min: 6,  pct: 15 },
    { min: 4,  pct: 10 },
    { min: 3,  pct: 0  },
  ];

  const PKG_PRICE = { valisette: 1200, pochon: 0 };
  const PKG_DESC  = {
    pochon:    '\u{1F45C} Pochon coton r\u00e9utilisable, ferm\u00e9 par un ruban Reseda. Offert d\u00e8s la 1\u00e8re s\u00e9lection.',
    valisette: '\u{1F9F3} Valisette signature identique \u00e0 nos coffrets \u2014 papier de soie inclus.',
  };

  /* ── CALCULS ── */
  function fillPct(n) {
    if (n <= 0) return 0;
    if (n < 4)  return n / 4 * 25;
    if (n < 6)  return 25 + (n - 4) / 2 * 25;
    if (n < 8)  return 50 + (n - 6) / 2 * 25;
    if (n < 10) return 75 + (n - 8) / 2 * 25;
    return 100;
  }

  function getNextMsg(n) {
    if (n === 0)  return { text: 'D\u00e8s 3 produits',                    color: '#A09890' };
    if (n < 3)    return { text: `Encore ${3 - n} produit${3 - n > 1 ? 's' : ''}`, color: '#C58C6D' };
    if (n === 3)  return { text: 'Encore 1 produit \u2192 \u221210%',       color: '#6B705C' };
    if (n === 4)  return { text: 'Encore 2 produits \u2192 \u221215%',      color: '#6B705C' };
    if (n === 5)  return { text: 'Encore 1 produit \u2192 \u221215%',       color: '#6B705C' };
    if (n === 6)  return { text: 'Encore 2 produits \u2192 \u221220%',      color: '#6B705C' };
    if (n === 7)  return { text: 'Encore 1 produit \u2192 \u221220%',       color: '#6B705C' };
    if (n === 8)  return { text: 'Encore 2 produits \u2192 \u221225%',      color: '#C58C6D' };
    if (n === 9)  return { text: 'Encore 1 produit \u2192 \u221225% \u{1F3AF}', color: '#C58C6D' };
    return { text: '\u221225% MAX \u{1F389}', color: '#6B705C' };
  }

  /* ── ÉTAT ── */
  let state = { quantities: {}, packaging: 'valisette', filter: 'all', drawerOpen: false, loading: false };

  function getDiscount(n) { for (const t of TIERS) if (n >= t.min) return t.pct; return -1; }
  function totalProducts() { return Object.values(state.quantities).reduce((s, q) => s + q, 0); }
  function formatPrice(cents) { return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0\u20ac'; }
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return [...(ctx || document).querySelectorAll(sel)]; }
  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ── PERSISTANCE SESSIONSTORAGE ── */
  function saveState() {
    try {
      sessionStorage.setItem('az_builder_state', JSON.stringify({
        quantities: state.quantities,
        packaging:  state.packaging,
      }));
    } catch(e) {}
  }

  function restoreState() {
    try {
      const saved = sessionStorage.getItem('az_builder_state');
      if (!saved) return;
      const parsed = JSON.parse(saved);
      if (parsed.quantities) state.quantities = parsed.quantities;
      if (parsed.packaging) {
        state.packaging = parsed.packaging;
        updatePackaging(parsed.packaging);
      }
      state.loading = false;
    } catch(e) {}
  }

  /* ── PRODUITS ── */
  function getProducts() {
    return qsa('.az-card[data-variant-id]').map(el => ({
      variantId:    el.dataset.variantId,
      price:        parseInt(el.dataset.price, 10),
      title:        el.dataset.title,
      rituel:       el.dataset.rituel,
      rituelLabel:  el.dataset.rituelLabel,
      image:        el.dataset.image,
      variantTitle: el.querySelector('.az-card__color-swatch--active')?.dataset.variantTitle || '',
    }));
  }

  /* ── RENDU GRILLE ── */
  function renderGrid() {
    qsa('.az-card[data-variant-id]').forEach(card => {
      const variantId = card.dataset.variantId;
      const rituel    = card.dataset.rituel;
      const price     = parseInt(card.dataset.price, 10);
      const qty       = state.quantities[variantId] || 0;
      card.style.display = (state.filter === 'all' || rituel === state.filter) ? '' : 'none';
      card.classList.toggle('az-card--selected', qty > 0);
      const btnWrap = qs('.az-card__btn-wrap', card);
      if (!btnWrap) return;
      if (qty > 0) {
        btnWrap.innerHTML = `
          <div class="az-card__qty">
            <button class="az-qty-btn az-qty-minus" data-id="${variantId}">${qty === 1 ? '\u2715' : '\u2212'}</button>
            <span class="az-qty-num">${qty}</span>
            <button class="az-qty-btn az-qty-plus" data-id="${variantId}">+</button>
          </div>`;
      } else {
        const p = formatPrice(price);
        btnWrap.innerHTML = `
          <button class="az-card__add-btn" data-id="${variantId}">
            <span class="az-card__add-btn__plus">+</span>
            <span class="az-card__add-btn__label-desktop">Ajouter \u00b7</span>
            <span>${p}</span>
          </button>`;
      }
    });
    const visible = qsa('.az-card[data-variant-id]').filter(c => c.style.display !== 'none');
    const countEl = qs('#az-grid-count');
    if (countEl) countEl.textContent = `${visible.length} produit${visible.length > 1 ? 's' : ''} disponible${visible.length > 1 ? 's' : ''}`;
  }

  /* ── RENDU TIER BAR ── */
  function renderTierBar() {
    const n = totalProducts();
    const d = getDiscount(n);
    const countEl = qs('#az-tier-count');
    if (countEl) {
      countEl.textContent = n;
      countEl.classList.remove('az-pulse');
      void countEl.offsetWidth;
      countEl.classList.add('az-pulse');
    }
    const discEl = qs('.az-tier__active-disc');
    if (discEl) {
      if (d > 0) { discEl.textContent = `\u2212${d}%`; discEl.classList.add('visible'); }
      else discEl.classList.remove('visible');
    }
    const fillEl = qs('#az-tier-fill');
    if (fillEl) fillEl.style.width = fillPct(n) + '%';
    const stepMap = { 'az-s4': n >= 4, 'az-s6': n >= 6, 'az-s8': n >= 8, 'az-s10': n >= 10 };
    Object.entries(stepMap).forEach(([id, active]) => {
      const el = qs('#' + id);
      if (el) el.classList.toggle('on', active);
    });
    const msgEl = qs('#az-tier-msg');
    if (msgEl) {
      const { text, color } = getNextMsg(n);
      msgEl.textContent = text;
      msgEl.style.color = color;
    }
  }

  /* ── RENDU SUMMARY ── */
  function renderSummary() {
    const n        = totalProducts();
    const d        = getDiscount(n);
    const pkgCents = PKG_PRICE[state.packaging];
    const products = getProducts();

    let subCents = 0;
    Object.entries(state.quantities).forEach(([vid, qty]) => {
      const p = products.find(x => x.variantId === vid);
      if (p) subCents += p.price * qty;
    });
    const savingCents = d > 0 ? Math.round(subCents * d / 100) : 0;
    const totalCents  = subCents - savingCents + pkgCents;

    const itemsHTML = Object.keys(state.quantities).length === 0
      ? '<p class="az-items__empty">Vos produits appara\u00eetront ici</p>'
      : Object.entries(state.quantities).map(([vid, qty]) => {
          const p = products.find(x => x.variantId === vid);
          if (!p) return '';
          return `<div class="az-item">
            <img class="az-item__thumb" src="${p.image}" alt="${p.title}" loading="lazy">
            <div class="az-item__info">
              <div class="az-item__name">${qty > 1 ? qty + '\u00d7 ' : ''}${p.title}</div>
              <div class="az-item__rituel">${p.rituelLabel}${p.variantTitle ? ' \u00b7 ' + p.variantTitle : ''}</div>
            </div>
            <span class="az-item__price">${formatPrice(p.price * qty)}</span>
            <button class="az-item__remove" data-id="${vid}">
              <svg width="11" height="11" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" viewBox="0 0 14 14">
                <line x1="3" y1="3" x2="11" y2="11"/><line x1="11" y1="3" x2="3" y2="11"/>
              </svg>
            </button>
          </div>`;
        }).join('');

    const discBadgeHTML = d > 0
      ? `<div class="az-discount-active-badge visible">\u{1F389} \u2212${d}% appliqu\u00e9 \u00b7 Vous \u00e9conomisez ${formatPrice(savingCents)}</div>`
      : '';

    let pricingHTML = `<div class="az-pricing__row"><span>Sous-total</span><span>${formatPrice(subCents)}</span></div>`;
    if (d > 0) pricingHTML += `<div class="az-pricing__row az-pricing__row--discount"><span>Remise \u2212${d}%</span><span>\u2212${formatPrice(savingCents)}</span></div>`;
    pricingHTML += totalCents >= 4900
      ? `<div class="az-pricing__row az-pricing__row--shipping-free"><span>\u{1F69A} Livraison</span><span>Offerte</span></div>`
      : `<div class="az-pricing__row az-pricing__row--shipping-locked"><span>\u{1F69A} Livraison</span><span>Offerte d\u00e8s 49\u20ac</span></div>`;
    if (pkgCents > 0) pricingHTML += `<div class="az-pricing__row"><span>Valisette premium</span><span>+${formatPrice(pkgCents)}</span></div>`;

    const { text: noticeText, color: noticeColor } = getNextMsg(n);
    const ctaEnabled = n >= MIN_PRODUCTS;

    /* MOBILE */
    const mCount   = qs('#az-m-count');
    const mTotal   = qs('#az-m-total');
    const mNotice  = qs('#az-m-notice');
    const mCta     = qs('#az-m-cta');
    const mItems   = qs('#az-m-items');
    const mPricing = qs('#az-m-pricing');
    const mReset   = qs('#az-m-reset');
    if (mCount)   mCount.textContent  = `${n} produit${n !== 1 ? 's' : ''}`;
    if (mTotal)   mTotal.textContent  = n > 0 ? formatPrice(totalCents) : '0,00\u00a0\u20ac';
    if (mNotice)  {
      mNotice.textContent = n < MIN_PRODUCTS
        ? (n === 0 ? `Ajoutez ${MIN_PRODUCTS} produits minimum` : `Encore ${MIN_PRODUCTS - n} produit${MIN_PRODUCTS - n > 1 ? 's' : ''} pour valider`)
        : noticeText;
      mNotice.className = 'az-cart-sticky__notice' + (n < MIN_PRODUCTS ? ' az-cart-sticky__notice--warn' : '');
      mNotice.style.color = n < MIN_PRODUCTS ? '' : noticeColor;
    }
    if (mCta)     { mCta.disabled = !ctaEnabled; mCta.textContent = state.loading ? 'Ajout\u2026' : 'Panier'; }
    if (mReset)   mReset.style.display = n > 0 ? 'block' : 'none';
    if (mItems)   mItems.innerHTML = itemsHTML;
    if (mPricing) { mPricing.style.display = n > 0 ? 'block' : 'none'; if (n > 0) mPricing.innerHTML = discBadgeHTML + pricingHTML; }

    /* DESKTOP */
    const dBadge   = qs('#az-d-badge');
    const dItems   = qs('#az-d-items');
    const dPricing = qs('#az-d-pricing');
    const dTotal   = qs('#az-d-total');
    const dTotalV  = qs('#az-d-total-val');
    const dNotice  = qs('#az-d-notice');
    const dCta     = qs('#az-d-cta');
    const dReset   = qs('#az-d-reset');
    if (dBadge)   dBadge.textContent = `${n} produit${n !== 1 ? 's' : ''}`;
    if (dItems)   dItems.innerHTML   = itemsHTML;
    if (dPricing) { dPricing.style.display = n > 0 ? 'block' : 'none'; if (n > 0) dPricing.innerHTML = discBadgeHTML + pricingHTML; }
    if (dTotal)   dTotal.style.display = n > 0 ? 'flex' : 'none';
    if (dTotalV)  dTotalV.textContent  = formatPrice(totalCents);
    if (dNotice)  {
      dNotice.textContent = n < MIN_PRODUCTS
        ? (n === 0 ? `Ajoutez ${MIN_PRODUCTS} produits minimum` : `Encore ${MIN_PRODUCTS - n} produit${MIN_PRODUCTS - n > 1 ? 's' : ''} pour valider`)
        : noticeText;
      dNotice.className = 'az-notice' + (n < MIN_PRODUCTS ? ' az-notice--warn' : '');
      dNotice.style.color = n < MIN_PRODUCTS ? '' : noticeColor;
    }
    if (dCta)     { dCta.disabled = !ctaEnabled; dCta.textContent = state.loading ? 'Ajout en cours\u2026' : 'Ajouter au panier'; }
    if (dReset)   dReset.style.display = n > 0 ? 'block' : 'none';
  }

  /* ── PACKAGING ── */
  function updatePackaging(type) {
    state.packaging = type;
    qsa('.az-pkg__opt').forEach(el => el.classList.toggle('az-pkg__opt--active', el.dataset.pkg === type));
    qsa('[data-pkg-desc]').forEach(el => { el.textContent = PKG_DESC[type]; });
  }

  /* ── DRAWER MOBILE ── */
  function toggleDrawer() {
    state.drawerOpen = !state.drawerOpen;
    const drawer = qs('#az-drawer');
    const toggle = qs('#az-drawer-toggle');
    if (drawer) drawer.classList.toggle('az-drawer--open', state.drawerOpen);
    if (toggle) toggle.classList.toggle('az-cart-sticky__toggle--open', state.drawerOpen);
  }

  /* ── FICHE RAPIDE (QUICK VIEW) ── */
  let qvCard      = null;   // carte produit actuellement affichée
  let qvData      = null;   // données JSON de la carte
  let qvLastFocus = null;   // élément à refocaliser à la fermeture
  let qvCloseTimer = null;

  // Identifie une image Shopify sans sa taille ni sa version (?v=…&width=…)
  function imgBase(url) {
    return String(url || '').split('?')[0].replace(/^https?:/, '');
  }

  function getQvData(card) {
    const el = card.querySelector('.az-qv-data');
    let data = {};
    if (el) { try { data = JSON.parse(el.textContent); } catch (e) { data = {}; } }
    const images = (Array.isArray(data.images) ? data.images : []).filter(Boolean);
    if (images.length === 0 && card.dataset.image) images.push(card.dataset.image);
    return {
      age:         data.age || card.dataset.age || '',
      description: data.description || '',
      images:      images,
      tags:        (Array.isArray(data.tags) ? data.tags : []).map(t => String(t || '').trim()).filter(Boolean),
    };
  }

  function renderQvMedia() {
    const track = qs('#az-qv-track');
    const dots  = qs('#az-qv-dots');
    if (!track || !dots || !qvData) return;
    const title = qvCard ? qvCard.dataset.title : '';
    track.innerHTML = qvData.images.map((src, i) => `
      <div class="az-qv__slide">
        <img src="${esc(src)}" alt="${esc(title)}${qvData.images.length > 1 ? ' \u2014 photo ' + (i + 1) : ''}" ${i > 0 ? 'loading="lazy"' : ''} width="800" height="800">
      </div>`).join('');
    track.scrollLeft = 0;
    dots.innerHTML = qvData.images.length > 1
      ? qvData.images.map((_, i) => `<button type="button" class="az-qv__dot${i === 0 ? ' on' : ''}" data-qv-dot="${i}" aria-label="Photo ${i + 1}"></button>`).join('')
      : '';
  }

  function updateQvDots() {
    const track = qs('#az-qv-track');
    if (!track || !track.clientWidth) return;
    const idx = Math.round(track.scrollLeft / track.clientWidth);
    qsa('.az-qv__dot').forEach((d, i) => d.classList.toggle('on', i === idx));
  }

  function scrollQvTo(index, smooth) {
    const track = qs('#az-qv-track');
    if (!track) return;
    track.scrollTo({ left: index * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
  }

  // Fait défiler le carrousel jusqu'à la photo du coloris choisi
  function scrollQvToVariant(variantImg, smooth) {
    if (!qvData || !variantImg) return;
    const target = imgBase(variantImg);
    const idx = qvData.images.findIndex(src => imgBase(src) === target);
    if (idx >= 0) scrollQvTo(idx, smooth);
  }

  // Met à jour les infos, coloris et bouton (appelé à chaque update())
  function renderQuickView() {
    const qv = qs('#az-qv');
    if (!qv || qv.hidden || !qvCard || !qvData) return;

    const variantId = qvCard.dataset.variantId;
    const price     = parseInt(qvCard.dataset.price, 10) || 0;
    const qty       = state.quantities[variantId] || 0;

    const ageEl   = qs('#az-qv-age');
    const titleEl = qs('#az-qv-title');
    const priceEl = qs('#az-qv-price');
    const descEl  = qs('#az-qv-desc');
    const tagsEl  = qs('#az-qv-tags');
    const varEl   = qs('#az-qv-variants');
    const ctaEl   = qs('#az-qv-cta');

    if (ageEl)   ageEl.textContent   = qvData.age;
    if (titleEl) titleEl.textContent = qvCard.dataset.title || '';
    if (priceEl) priceEl.textContent = formatPrice(price);
    if (descEl)  descEl.textContent  = qvData.description;
    if (tagsEl)  tagsEl.innerHTML    = qvData.tags.map(t => `<span class="az-qv__tag">${esc(t)}</span>`).join('');

    if (varEl) {
      const swatches = qsa('.az-card__color-swatch', qvCard);
      if (swatches.length > 1) {
        const active = swatches.find(s => s.classList.contains('az-card__color-swatch--active')) || swatches[0];
        varEl.innerHTML = `
          <div class="az-qv__variants-label">Coloris : <strong>${esc(active.dataset.variantTitle)}</strong></div>
          <div class="az-qv__swatches">
            ${swatches.map(s => `
              <button type="button"
                class="az-qv__swatch${s === active ? ' az-qv__swatch--active' : ''}"
                data-qv-variant="${esc(s.dataset.variantId)}"
                style="background-color:${esc(s.style.backgroundColor)}"
                aria-label="${esc(s.dataset.variantTitle)}"
                title="${esc(s.dataset.variantTitle)}"></button>`).join('')}
          </div>`;
      } else {
        varEl.innerHTML = '';
      }
    }

    if (ctaEl) {
      ctaEl.innerHTML = qty > 0
        ? `<div class="az-qv__qty">
             <button type="button" class="az-qty-btn" data-qv-minus aria-label="Retirer un">${qty === 1 ? '\u2715' : '\u2212'}</button>
             <span class="az-qty-num">${qty}</span>
             <button type="button" class="az-qty-btn" data-qv-plus aria-label="Ajouter un">+</button>
           </div>
           <div class="az-qv__qty-label">\u2713 Dans votre coffret</div>`
        : `<button type="button" class="az-qv__add" data-qv-plus>+ Ajouter au coffret \u00b7 ${formatPrice(price)}</button>`;
    }
  }

  function openQuickView(card) {
    const qv = qs('#az-qv');
    if (!qv || !card) return;
    clearTimeout(qvCloseTimer);
    qvCard      = card;
    qvData      = getQvData(card);
    qvLastFocus = document.activeElement;

    qv.hidden = false;
    renderQvMedia();
    renderQuickView();
    void qv.offsetWidth;                 // force le reflow pour l'animation
    qv.classList.add('is-open');
    document.documentElement.classList.add('az-qv-lock');

    // Afficher directement la photo du coloris sélectionné sur la carte
    const active = card.querySelector('.az-card__color-swatch--active');
    if (active) requestAnimationFrame(() => scrollQvToVariant(active.dataset.variantImg, false));

    const closeBtn = qs('.az-qv__close', qv);
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }

  function closeQuickView() {
    const qv = qs('#az-qv');
    if (!qv || qv.hidden) return;
    qv.classList.remove('is-open');
    document.documentElement.classList.remove('az-qv-lock');
    clearTimeout(qvCloseTimer);
    qvCloseTimer = setTimeout(() => {
      qv.hidden = true;
      qvCard = null;
      qvData = null;
    }, 350);
    if (qvLastFocus && typeof qvLastFocus.focus === 'function') qvLastFocus.focus({ preventScroll: true });
  }

  function bindQuickView() {
    const qv = qs('#az-qv');
    if (!qv) return;

    qv.addEventListener('click', e => {
      if (e.target.closest('[data-qv-close]')) { closeQuickView(); return; }
      if (!qvCard) return;

      // Coloris → on clique la pastille de la carte (synchro carte + photo + récap)
      const sw = e.target.closest('.az-qv__swatch');
      if (sw) {
        const cardSwatch = qsa('.az-card__color-swatch', qvCard).find(s => s.dataset.variantId === sw.dataset.qvVariant);
        if (cardSwatch) {
          cardSwatch.click();
          renderQuickView();
          scrollQvToVariant(cardSwatch.dataset.variantImg, true);
        }
        return;
      }

      const dot = e.target.closest('[data-qv-dot]');
      if (dot) { scrollQvTo(parseInt(dot.dataset.qvDot, 10), true); return; }

      const id = qvCard.dataset.variantId;
      if (e.target.closest('[data-qv-plus]')) {
        state.quantities[id] = (state.quantities[id] || 0) + 1;
        update();
        return;
      }
      if (e.target.closest('[data-qv-minus]')) {
        const q = (state.quantities[id] || 1) - 1;
        if (q <= 0) delete state.quantities[id]; else state.quantities[id] = q;
        update();
      }
    });

    const track = qs('#az-qv-track');
    if (track) {
      let ticking = false;
      track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => { updateQvDots(); ticking = false; });
      }, { passive: true });
    }

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !qv.hidden) closeQuickView();
    });
  }

  // Photo + nom des cartes accessibles au clavier
  function prepareQvTriggers() {
    qsa('.az-card .az-card__img, .az-card .az-card__name').forEach(el => {
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      const card = el.closest('.az-card');
      if (card && !el.getAttribute('aria-label')) el.setAttribute('aria-label', 'Voir la fiche : ' + (card.dataset.title || ''));
    });
  }

  /* ── NOTIFIER FOCAL ── */
  function notifyFocal() {
    // Recharger le drawer Focal via sa méthode native
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer._rerenderCart === 'function') {
      cartDrawer._rerenderCart({ detail: null });
    }
    // Mettre à jour le compteur icône panier
    const cartCount = document.querySelector('cart-count');
    if (cartCount && typeof cartCount._updateCartCount === 'function') {
      cartCount._updateCartCount({ detail: null });
    }
  }

  /* ── VIDAGE SÉLECTIF DU PANIER ── */
  async function clearBuilderItems() {
    try {
      const cartRes = await fetch('/cart.js', {
        headers: { 'Accept': 'application/json' }
      });
      const cart = await cartRes.json();

      const builderKeys = cart.items
        .filter(item => item.properties && item.properties._coffret_sur_mesure === 'true')
        .map(item => item.key);

      const packagingKeys = cart.items
        .filter(item => item.properties && item.properties._packaging_coffret === 'true')
        .map(item => item.key);

      const allBuilderKeys = [...builderKeys, ...packagingKeys];
      if (allBuilderKeys.length === 0) return;

      const updates = {};
      allBuilderKeys.forEach(key => { updates[key] = 0; });

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates }),
      });
    } catch(e) {
      console.error('[AZ Builder] clearBuilderItems error:', e);
    }
  }

  /* ── CART API + CHECKOUT DIRECT ── */
  async function addToCart() {
    if (state.loading) return;
    const n = totalProducts();
    if (n < MIN_PRODUCTS) return;
    state.loading = true;
    renderSummary();

    const items = [];
    Object.entries(state.quantities).forEach(([variantId, qty]) => {
      items.push({
        id: parseInt(variantId, 10),
        quantity: qty,
        properties: { _coffret_sur_mesure: 'true', _packaging: state.packaging }
      });
    });

    const pkgVariantId = state.packaging === 'valisette' ? VALISETTE_VARIANT_ID : POCHON_VARIANT_ID;
    if (pkgVariantId) {
      items.push({
        id: parseInt(pkgVariantId, 10),
        quantity: 1,
        properties: { _packaging_coffret: 'true' }
      });
    }

    try {
      await clearBuilderItems();

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!response.ok) throw new Error('Cart API error');

      notifyFocal();

      const d = getDiscount(n);
      const discountCodes = { 10: 'COFFRET10', 15: 'COFFRET15', 20: 'COFFRET20', 25: 'COFFRET25' };
      const code = discountCodes[d];
      state.loading = false;
      saveState();
      window.location.href = code ? `/checkout?discount=${code}` : '/checkout';

    } catch (err) {
      console.error('[AZ Builder] Cart error:', err);
      alert('Une erreur est survenue. Merci de r\u00e9essayer.');
      state.loading = false;
      renderSummary();
    }
  }

  /* ── EVENTS ── */
  function bindEvents() {
    const grid = qs('#az-grid');
    if (grid) {
      grid.addEventListener('click', e => {
        const swatch = e.target.closest('.az-card__color-swatch');
        if (swatch) {
          const card         = swatch.closest('.az-card');
          const variantId    = swatch.dataset.variantId;
          const variantImg   = swatch.dataset.variantImg;
          const variantTitle = swatch.dataset.variantTitle;
          card.querySelectorAll('.az-card__color-swatch').forEach(s =>
            s.classList.remove('az-card__color-swatch--active')
          );
          swatch.classList.add('az-card__color-swatch--active');
          const img = card.querySelector('.az-card__img img');
          if (img && variantImg) { img.src = variantImg; img.alt = variantTitle; }
          card.dataset.variantId = variantId;
          const addBtn   = card.querySelector('.az-card__add-btn');
          const minusBtn = card.querySelector('.az-qty-minus');
          const plusBtn  = card.querySelector('.az-qty-plus');
          if (addBtn)   addBtn.dataset.id   = variantId;
          if (minusBtn) minusBtn.dataset.id = variantId;
          if (plusBtn)  plusBtn.dataset.id  = variantId;
          return;
        }

        const qvTrigger = e.target.closest('.az-card__img, .az-card__name');
        if (qvTrigger) {
          openQuickView(qvTrigger.closest('.az-card'));
          return;
        }

        const addBtn   = e.target.closest('.az-card__add-btn');
        const plusBtn  = e.target.closest('.az-qty-plus');
        const minusBtn = e.target.closest('.az-qty-minus');
        if (addBtn)   { const id = addBtn.dataset.id;   state.quantities[id] = (state.quantities[id] || 0) + 1; update(); }
        if (plusBtn)  { const id = plusBtn.dataset.id;  state.quantities[id] = (state.quantities[id] || 0) + 1; update(); }
        if (minusBtn) { const id = minusBtn.dataset.id; const q = (state.quantities[id] || 1) - 1; if (q <= 0) delete state.quantities[id]; else state.quantities[id] = q; update(); }
      });

      grid.addEventListener('keydown', e => {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        const qvTrigger = e.target.closest('.az-card__img, .az-card__name');
        if (!qvTrigger) return;
        e.preventDefault();
        openQuickView(qvTrigger.closest('.az-card'));
      });
    }

    bindQuickView();

    const filtersEl = qs('#az-filters');
    if (filtersEl) {
      filtersEl.addEventListener('click', e => {
        const btn = e.target.closest('.az-filter-btn');
        if (!btn) return;
        qsa('.az-filter-btn').forEach(b => b.classList.remove('az-filter-btn--active'));
        btn.classList.add('az-filter-btn--active');
        state.filter = btn.dataset.filter;
        renderGrid();
      });
    }

    document.addEventListener('click', e => {
      const opt = e.target.closest('.az-pkg__opt');
      if (opt && opt.dataset.pkg) { updatePackaging(opt.dataset.pkg); renderSummary(); saveState(); }
      const rm = e.target.closest('.az-item__remove');
      if (rm) { const id = rm.dataset.id; delete state.quantities[id]; update(); }
    });

    // Bouton vider sélection
    document.addEventListener('click', function(e) {
      if (!e.target.closest('#az-d-reset, #az-m-reset')) return;
      e.preventDefault();
      state.quantities = {};
      updatePackaging('pochon');
      clearBuilderItems().then(function() {
        notifyFocal();
      });
      update();
    });

    const drawerBar = qs('#az-drawer-bar');
    if (drawerBar) drawerBar.addEventListener('click', toggleDrawer);

    const mCta = qs('#az-m-cta');
    if (mCta) {
      mCta.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        if (state.loading) return;
        addToCart();
      });
    }

    const dCta = qs('#az-d-cta');
    if (dCta) {
      dCta.addEventListener('click', e => {
        e.preventDefault();
        if (state.loading) return;
        addToCart();
      });
    }

    // Synchronisation drawer → builder
    document.addEventListener('cart:updated', function() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          const newQuantities = {};
          cart.items.forEach(function(item) {
            if (item.properties && item.properties._coffret_sur_mesure === 'true') {
              newQuantities[item.variant_id.toString()] = item.quantity;
            }
          });
          state.quantities = newQuantities;
          renderGrid();
          renderSummary();
          renderTierBar();
          renderQuickView();
          saveState();
        });
    });
  }

  /* ── MISE À JOUR GLOBALE ── */
  function update() {
    renderGrid();
    renderSummary();
    renderTierBar();
    renderQuickView();
    saveState();
    // Synchroniser le panier Shopify à chaque modification puis notifier Focal
    syncCartWithBuilder().then(function() {
      notifyFocal();
    });
  }

async function syncCartWithBuilder() {
  try {
    const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    const cart = await cartRes.json();

    const updates = {};

    // Mettre à zéro tous les produits builder existants
    cart.items.forEach(function(item) {
      if (item.properties && (item.properties._coffret_sur_mesure === 'true' || item.properties._packaging_coffret === 'true')) {
        updates[item.key] = 0;
      }
    });

    // Si sélection vide — juste vider, pas remettre
    if (totalProducts() === 0) {
      if (Object.keys(updates).length === 0) return;
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates }),
      });
      return;
    }

    // Appliquer les suppressions puis remettre les produits actuels
    if (Object.keys(updates).length > 0) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates }),
      });
    }

    // Reconstruire le panier avec la sélection actuelle du builder
    const items = [];
    Object.entries(state.quantities).forEach(function([variantId, qty]) {
      items.push({
        id: parseInt(variantId, 10),
        quantity: qty,
        properties: { _coffret_sur_mesure: 'true', _packaging: state.packaging }
      });
    });

    const pkgVariantId = state.packaging === 'valisette' ? VALISETTE_VARIANT_ID : POCHON_VARIANT_ID;
    if (pkgVariantId) {
      items.push({
        id: parseInt(pkgVariantId, 10),
        quantity: 1,
        properties: { _packaging_coffret: 'true' }
      });
    }

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items }),
    });

  } catch(e) {
    console.error('[AZ Builder] syncCartWithBuilder error:', e);
  }
}

  function init() {
    restoreState();
    prepareQvTriggers();
    bindEvents();
    state.loading = false;
    update();
    setTimeout(function() {
      state.loading = false;
      renderSummary();
    }, 200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

})();